var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.035 3.55875C25.7884 2.19755 24.6133 1.20627 23.2497 0.896794C21.2091 0.464015 17.4326 0.154541 13.3466 0.154541C9.26295 0.154541 5.42597 0.464015 3.38296 0.896794C2.02176 1.20627 0.844304 2.13469 0.597692 3.55875C0.348663 5.10612 0.102051 7.27244 0.102051 10.0577C0.102051 12.843 0.348663 15.0093 0.658137 16.5566C0.907166 17.9178 2.0822 18.9091 3.4434 19.2186C5.60972 19.6514 9.3234 19.9609 13.4094 19.9609C17.4954 19.9609 21.2091 19.6514 23.3754 19.2186C24.7366 18.9091 25.9117 17.9807 26.1607 16.5566C26.4073 15.0093 26.7168 12.7801 26.7796 10.0577C26.6539 7.27244 26.3444 5.10612 26.035 3.55875ZM10.0052 14.3903V5.72507L17.5559 10.0577L10.0052 14.3903Z",
    fill: "#F5FCFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.32603b1c.svg";
export { ForwardRef as ReactComponent };